// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-36392a70] .el-badge__content {\r\n  background: #3061f1;\n}\r\n", ""]);
// Exports
module.exports = exports;
